<template>
  <div class="fx-theme--light">
  <div class="calculator-section">
      <div class="calculator-holder">
          <div class="container">
              <div class="row justify-content-center">
                  <div class="col-md-10 heading-title">
                      <h1 class="animated text-center fx-animation-fadeInUp">
                        {{ title }}
                      </h1>
                      <p v-show="currentCalculator == 'price'" class="animated text-center fx-animation-fadeInUp">
                        {{ $t('price_subtitle') }}
                      </p>
                      <p v-show="currentCalculator == 'profit'" class="animated text-center fx-animation-fadeInUp">
                        {{ $t('profit_subtitle_1') }}
                      </p>
                      <p v-show="currentCalculator == 'profit'" class="animated text-center fx-animation-fadeInUp">
                        {{ $t('profit_subtitle_2') }}
                      </p>
                  </div>
              </div>
          </div>
          <div class="background-theme">
            <PriceCalculator v-if="currentCalculator == 'price'" />
            <ProfitCalculator v-else-if="currentCalculator == 'profit'"/>
          </div>
          <div class="container">
              <div class="row columns">
                  <div class="col-12">
                      <h2 class="text-center">
                        {{ bottomTitle }}
                      </h2>
                  </div>

                  <div v-show="currentCalculator == 'price'" class="col-12 fx-font-size-base-xs">
                      <p>
                        {{ $t('price_bottom_text_1') }}
                      </p>
                      <div class="text-example fx-color--success text-center">
                        <strong>
                          $$P(n) = (1 + (n \text{ div } 1e6))^{0.3}$$
                        </strong>
                        <div>
                          <span>{{ $t('where') }}</span>
                          <span> ##n## </span>
                          <span>- {{ $t('number_of_sold_tokens') }}</span>
                        </div>
                      </div>
                      <p>
                        {{ $t('price_bottom_text_2') }}
                      </p>
                  </div>

                  <div v-show="currentCalculator == 'profit'" class="col-12 fx-font-size-base-xs">
                      <p>
                        {{ $t('profit_bottom_text_1') }}
                      </p>
                      <div class="text-example fx-color--success">
                        <strong class="long-formula">
                          $$ K(S_j, S_c) = { M_r  M_i \sum_{i=1}^{S_c} P(i) ( F_d (1 - F_a) (1 - F_{cha} - F_{dev}) + F_p)) \over F_p S_c P(S_j)} - 1.0 $$
                        </strong>
                        <div>
                          {{ $t('where') }},
                          <ul>
                            <li><span>##M_r##</span><span> - {{ $t('share_of_funds_to_buy_copyrights')}}</span></li>
                            <li><span>##M_i##</span><span> - {{ $t('investor_share')}}</span></li>
                            <li><span>##S_j##</span><span> - {{ $t('round_buy')}}</span></li>
                            <li><span>##S_c##</span><span> - {{ $t('round_profit')}}</span></li>
                            <li><span>##P(n)##</span><span> - {{ $t('price_at_round')}}</span><span> ##n##</span></li>
                            <li><span>##F_d##</span><span> - {{ $t('fee_issue')}}</span></li>
                            <li><span>##F_a##</span><span> - {{ $t('fee_agent')}}</span></li>
                            <li><span>##F_p##</span><span> - {{ $t('presale_volume')}}</span></li>
                            <li><span>##F_{cha}##</span><span> - {{ $t('charity_fee')}}</span></li>
                            <li><span>##F_{dev}##</span><span> - {{ $t('development_fee')}}</span></li>
                          </ul>
                        </div>
                      </div>
                  </div>

              </div>
          </div>
      </div>
  </div>
  </div>
</template>

<script>
import PriceCalculator from './PriceCalculator.vue'
import ProfitCalculator from './ProfitCalculator.vue'

export default {
  props: [
    'currentCalculator',
    'title',
    'subtitle',
    'bottomTitle',
  ],
  components: {
    PriceCalculator,
    ProfitCalculator,
  },
}
</script>

<style>
@import 'https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap';

*, :after, :before {
    box-sizing: border-box;
}

html {
  font-size: 14px;
}

body {
    font-family: Inter,Segoe UI,Arial,sans-serif,Apple Color Emoji,Segoe UI Emoji,Segoe UI Symbol;
    color: #636e72;
    -webkit-font-smoothing: antialiased;
}
body {
    margin: 0;
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.5;
    color: #212529;
    text-align: left;
    background-color: #fff;
}


@media screen and (min-width: 480px) {
  html {
    font-size: 14px;
  }
}

@media screen and (min-width: 1024px) {
  html {
    font-size: 16px;
  }
}
</style>

<style scoped>
.calculator-section {
  margin-top: 32px;
}
.fx-theme--light {
    color: #636e72;
    background-color: #fff;
}
.background-theme {
    background: #f5f6f7;
    padding: 20px 0;
    margin-bottom: 20px;
}

.container {
    width: 100%;
    padding-right: 20px;
    padding-left: 20px;
    margin-right: auto;
    margin-left: auto;
}
.justify-content-center {
    justify-content: center!important;
}
.row {
    display: flex;
    flex-wrap: wrap;
    margin-right: -20px;
    margin-left: -20px;
}
.columns {
    margin-bottom: 70px;
}
.col, .col-1, .col-2, .col-3, .col-4, .col-5, .col-6, .col-7, .col-8, .col-9, .col-10, .col-11, .col-12, .col-auto, .col-lg, .col-lg-1, .col-lg-2, .col-lg-3, .col-lg-4, .col-lg-5, .col-lg-6, .col-lg-7, .col-lg-8, .col-lg-9, .col-lg-10, .col-lg-11, .col-lg-12, .col-lg-auto, .col-md, .col-md-1, .col-md-2, .col-md-3, .col-md-4, .col-md-5, .col-md-6, .col-md-7, .col-md-8, .col-md-9, .col-md-10, .col-md-11, .col-md-12, .col-md-auto, .col-sm, .col-sm-1, .col-sm-2, .col-sm-3, .col-sm-4, .col-sm-5, .col-sm-6, .col-sm-7, .col-sm-8, .col-sm-9, .col-sm-10, .col-sm-11, .col-sm-12, .col-sm-auto, .col-xl, .col-xl-1, .col-xl-2, .col-xl-3, .col-xl-4, .col-xl-5, .col-xl-6, .col-xl-7, .col-xl-8, .col-xl-9, .col-xl-10, .col-xl-11, .col-xl-12, .col-xl-auto {
    position: relative;
    width: 100%;
    min-height: 1px;
    padding-right: 20px;
    padding-left: 20px;
}
.col-12 {
    flex: 0 0 100%;
    max-width: 100%;
}
.heading-title {
    margin-bottom: 40px;
}
.heading-title p {
    margin-bottom: 0;
}
h1, h2, h3, h4, h5, h6 {
    margin-top: 0;
    margin-bottom: .5rem;
}
.text-size-h1, .text-size-h2, .text-size-h3, .text-size-h4, .text-size-h5, .text-size-h6, h1, h2, h3, h4, h5, h6 {
    font-weight: 500;
    font-family: Futura,Inter,Segoe UI,Arial,sans-serif,Apple Color Emoji,Segoe UI Emoji,Segoe UI Symbol;
    margin-bottom: .6em;
    color: #2d3436;
}
.fx-theme--light .fx-color--heading, .fx-theme--light .text-size-h3, .fx-theme--light .text-size-h4, .fx-theme--light .text-size-h5, .fx-theme--light .text-size-h6, .fx-theme--light h1, .fx-theme--light h2, .fx-theme--light h3, .fx-theme--light h4, .fx-theme--light h5, .fx-theme--light h6 {
    color: #2d3436;
}
.text-size-h1, h1 {
    font-size: 36px;
    line-height: 1.3;
}
.text-size-h2, h2 {
    font-size: 1.75rem;
    line-height: 1.2142857143;
}
.text-size-h4, h4 {
    font-size: 1.375rem;
    line-height: 1.0909090909;
}
.text-center {
    text-align: center!important;
}
.animated, .fx-animation-tada {
    -webkit-animation-duration: 1s;
    animation-duration: 1s;
    -webkit-animation-fill-mode: both;
    animation-fill-mode: both;
}
.animated {
    opacity: 0;
}
.fx-animation-fadeInUp {
    -webkit-animation-name: fx-animation-fadeInUp;
    animation-name: fx-animation-fadeInUp;
}
.fx-theme--light .text-size-h4 {
    font-weight: 500;
    color: #00b894;
}
.fx-font-size-base-xs {
    font-size: 14px;
}
.text-example strong {
    -webkit-tap-highlight-color: rgba(0,0,0,0);
    -webkit-text-size-adjust: 100%;
    line-height: 1.5;
    text-align: left;
    -webkit-font-smoothing: antialiased;
    color: rgb(15, 150, 180);
    font-size: 16px;
    font-family: Futura,Inter,Segoe UI,Arial,sans-serif,Apple Color Emoji,Segoe UI Emoji,Segoe UI Symbol;
    box-sizing: border-box;
    font-weight: 500;
}

.text-example strong.long-formula {
  font-size: 11px;
}

.table-responsive {
    display: block;
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    -ms-overflow-style: -ms-autohiding-scrollbar;
}
@media screen and (min-width: 480px) {
  .text-size-h2, h2 {
    font-size: 2.2857142857rem;
    line-height: 1.0625;
  }
  .text-size-h4, h4 {
    font-size: 1.7142857143rem;
    line-height: 1.1666666667;
  }
  .text-example strong.long-formula {
    font-size: 14px;
  }
}
@media screen and (min-width: 1024px) {
  .text-example strong.long-formula {
    font-size: 16px;
  }
  .background-theme {
    padding: 80px 0;
    margin-bottom: 80px;
  }
  .col-md-10 {
    flex: 0 0 83.3333333333%;
    max-width: 83.3333333333%;
  }
  .col-md-6 {
    flex: 0 0 50%;
    max-width: 50%;
  }
  .col-md-12 {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .heading-title {
    margin-bottom: 60px;
  }
  .text-size-h1, .text-size-h2, .text-size-h3, .text-size-h4, .text-size-h5, .text-size-h6, h1, h2, h3, h4, h5, h6 {
    margin-bottom: .6em;
  }
  .text-size-h1, h1 {
    font-size: 46px;
  }
  .text-size-h2, h2 {
    font-size: 2.25rem;
    line-height: 1.2777777778;
  }
  .text-size-h4, h4 {
    font-size: 1.625rem;
    line-height: 1.3076923077;
  }
}
@media screen and (min-width: 1200px) {
  .container {
    max-width: 1200px;
  }
}


.table {
      -webkit-tap-highlight-color: rgba(0,0,0,0);
    -webkit-text-size-adjust: 100%;
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.5;
    text-align: left;
    font-family: Inter,Segoe UI,Arial,sans-serif,Apple Color Emoji,Segoe UI Emoji,Segoe UI Symbol;
    -webkit-font-smoothing: antialiased;
    color: #636e72;
    box-sizing: border-box;
    border-collapse: collapse;
    width: 100%;
    max-width: 100%;
    background-color: transparent;
    margin-bottom: 15px;
}

.notes p {
    font-size: 12px;
    margin-bottom: 10px;
}

.table   td, .table   th {
    padding: .75rem;
    vertical-align: top;
    border-top: 1px solid #dee2e6;
}
.table   thead   th {
    vertical-align: bottom;
    border-bottom: 2px solid #dee2e6;
}
.table   thead   th {
    border-top: 0;
    border-bottom-width: 1px;
}
.table td:not(:first-child), .table th:not(:first-child) {
    border-left: 1px solid #dee2e6;
}
.table td, .table th {
    padding: .75rem;
    vertical-align: top;
    border-top: 1px solid #dee2e6;
}
.table td:not(:first-child), .table th:not(:first-child) {
    border-left: 1px solid #dee2e6;
}

@-webkit-keyframes fx-animation-tada{0%{transform:scaleX(1)}10%,20%{transform:scale3d(.95,.95,.95) rotate(-3deg)}30%,50%,70%,90%{transform:scale3d(1.05,1.05,1.05) rotate(3deg)}40%,60%,80%{transform:scale3d(1.05,1.05,1.05) rotate(-3deg)}to{transform:scaleX(1)}}@keyframes fx-animation-tada{0%{transform:scaleX(1)}10%,20%{transform:scale3d(.95,.95,.95) rotate(-3deg)}30%,50%,70%,90%{transform:scale3d(1.05,1.05,1.05) rotate(3deg)}40%,60%,80%{transform:scale3d(1.05,1.05,1.05) rotate(-3deg)}to{transform:scaleX(1)}}.fx-animation-tada{-webkit-animation-name:fx-animation-tada;animation-name:fx-animation-tada}.animated,.fx-animation-tada{-webkit-animation-duration:1s;animation-duration:1s;-webkit-animation-fill-mode:both;animation-fill-mode:both}.animated{opacity:0}.animated.initially-visible{opacity:1}.fx-animation-fadeInUp{-webkit-animation-name:fx-animation-fadeInUp;animation-name:fx-animation-fadeInUp}.fx-animation-fadeInDown{-webkit-animation-name:fx-animation-fadeInDown;animation-name:fx-animation-fadeInDown}.fx-animation-fadeInDown20px{-webkit-animation-name:fx-animation-fadeInDown20px;animation-name:fx-animation-fadeInDown20px}.fx-animation-fadeInDown5px{-webkit-animation-name:fx-animation-fadeInDown5px;animation-name:fx-animation-fadeInDown5px}.fx-animation-fadeOutUp20px{-webkit-animation-name:fx-animation-fadeOutUp20px;animation-name:fx-animation-fadeOutUp20px}.fx-animation-fadeInUp20px{-webkit-animation-name:fx-animation-fadeInUp20px;animation-name:fx-animation-fadeInUp20px}@-webkit-keyframes fx-animation-fadeInUp20px{0%{opacity:0;transform:translate3d(0,20px,0)}to{opacity:1;transform:none}}@keyframes fx-animation-fadeInUp20px{0%{opacity:0;transform:translate3d(0,20px,0)}to{opacity:1;transform:none}}.fx-animation-fadeInUp50px{-webkit-animation-name:fx-animation-fadeInUp50px;animation-name:fx-animation-fadeInUp50px}@-webkit-keyframes fx-animation-fadeInUp50px{0%{opacity:0;transform:translate3d(0,50px,0)}to{opacity:1;transform:none}}@keyframes fx-animation-fadeInUp50px{0%{opacity:0;transform:translate3d(0,50px,0)}to{opacity:1;transform:none}}.fx-animation-fadeInUp100px{-webkit-animation-name:fx-animation-fadeInUp100px;animation-name:fx-animation-fadeInUp100px}@-webkit-keyframes fx-animation-fadeInUp100px{0%{opacity:0;transform:translate3d(0,100px,0)}to{opacity:1;transform:none}}@keyframes fx-animation-fadeInUp100px{0%{opacity:0;transform:translate3d(0,100px,0)}to{opacity:1;transform:none}}.fx-animation-fadeInUp150px{-webkit-animation-name:fx-animation-fadeInUp150px;animation-name:fx-animation-fadeInUp150px}@-webkit-keyframes fx-animation-fadeInUp150px{0%{opacity:0;transform:translate3d(0,150px,0)}to{opacity:1;transform:none}}@keyframes fx-animation-fadeInUp150px{0%{opacity:0;transform:translate3d(0,150px,0)}to{opacity:1;transform:none}}.fx-animation-fadeInUp200px{-webkit-animation-name:fx-animation-fadeInUp200px;animation-name:fx-animation-fadeInUp200px}@-webkit-keyframes fx-animation-fadeInUp200px{0%{opacity:0;transform:translate3d(0,200px,0)}to{opacity:1;transform:none}}@keyframes fx-animation-fadeInUp200px{0%{opacity:0;transform:translate3d(0,200px,0)}to{opacity:1;transform:none}}.fx-animation-fadeInRightUp{-webkit-animation-name:fx-animation-fadeInRightUp;animation-name:fx-animation-fadeInRightUp}@-webkit-keyframes fx-animation-fadeInRightUp{0%{opacity:0;transform:translate3d(500px,300px,0)}to{opacity:1;transform:none}}@keyframes fx-animation-fadeInRightUp{0%{opacity:0;transform:translate3d(500px,300px,0)}to{opacity:1;transform:none}}.fx-animation-fadeInRightUpPhone{-webkit-animation-name:fx-animation-fadeInRightUpPhone;animation-name:fx-animation-fadeInRightUpPhone}@-webkit-keyframes fx-animation-fadeInRightUpPhone{0%{opacity:0;transform:translate3d(240px,610px,0)}to{opacity:1;transform:none}}@keyframes fx-animation-fadeInRightUpPhone{0%{opacity:0;transform:translate3d(240px,610px,0)}to{opacity:1;transform:none}}.fx-animation-fadeLeftUp{-webkit-animation-name:fx-animation-fadeLeftUp;animation-name:fx-animation-fadeLeftUp}@-webkit-keyframes fx-animation-fadeLeftUp{0%{opacity:0;transform:translate3d(-200px,300px,0)}to{opacity:1;transform:none}}@keyframes fx-animation-fadeLeftUp{0%{opacity:0;transform:translate3d(-200px,300px,0)}to{opacity:1;transform:none}}.fx-animation-fadeInRight200px{-webkit-animation-name:fx-animation-fadeInRight200px;animation-name:fx-animation-fadeInRight200px}.animated.infinite{-webkit-animation-iteration-count:infinite;animation-iteration-count:infinite}.animated.hinge{-webkit-animation-duration:2s;animation-duration:2s}.fx-animation-boxShadowPulse{-webkit-animation:fx-animation-boxShadowPulse .5s;animation:fx-animation-boxShadowPulse .5s}.fx-animation-showUpOpacity{-webkit-animation-name:fx-animation-showUpOpacity;animation-name:fx-animation-showUpOpacity}.fx-animation-slideInRight{-webkit-animation-name:fx-animation-slideInRight;animation-name:fx-animation-slideInRight}.fx-animation-slideInLeft{-webkit-animation-name:fx-animation-slideInLeft;animation-name:fx-animation-slideInLeft}.fx-animation-step1{-webkit-animation-name:fx-animation-step1;animation-name:fx-animation-step1;-webkit-animation-delay:.8s;animation-delay:.8s;-webkit-animation-duration:.5s;animation-duration:.5s;-webkit-animation-timing-function:ease-out;animation-timing-function:ease-out}.fx-animation-step{-webkit-animation-name:fx-animation-step;animation-name:fx-animation-step;-webkit-animation-duration:.3s;animation-duration:.3s;-webkit-animation-timing-function:ease-out;animation-timing-function:ease-out}@-webkit-keyframes fx-animation-step1{0%{opacity:1;transform:translateX(170%)}to{transform:translateX(0);opacity:1}}@keyframes fx-animation-step1{0%{opacity:1;transform:translateX(170%)}to{transform:translateX(0);opacity:1}}@-webkit-keyframes fx-animation-step{0%{transform:translateX(-116%);opacity:0}1%{transform:translateX(-116%);opacity:1}to{transform:translateX(0);opacity:1}}@keyframes fx-animation-step{0%{transform:translateX(-116%);opacity:0}1%{transform:translateX(-116%);opacity:1}to{transform:translateX(0);opacity:1}}@-webkit-keyframes fx-animation-showUpOpacity{0%{opacity:0}to{opacity:1}}@keyframes fx-animation-showUpOpacity{0%{opacity:0}to{opacity:1}}@-webkit-keyframes fx-animation-slideInBottom50px{0%{transform:translateY(50px)}to{transform:translateY(0)}}@keyframes fx-animation-slideInBottom50px{0%{transform:translateY(50px)}to{transform:translateY(0)}}@-webkit-keyframes fx-animation-fadeInUp{0%{opacity:0;transform:translate3d(0,50%,0)}to{opacity:1;transform:none}}@keyframes fx-animation-fadeInUp{0%{opacity:0;transform:translate3d(0,50%,0)}to{opacity:1;transform:none}}@-webkit-keyframes fx-animation-fadeInDown{0%{opacity:0;transform:translate3d(0,-50%,0)}to{opacity:1;transform:none}}@keyframes fx-animation-fadeInDown{0%{opacity:0;transform:translate3d(0,-50%,0)}to{opacity:1;transform:none}}@-webkit-keyframes fx-animation-fadeInDown20px{0%{opacity:0;transform:translate3d(0,-20px,0)}to{opacity:1;transform:none}}@keyframes fx-animation-fadeInDown20px{0%{opacity:0;transform:translate3d(0,-20px,0)}to{opacity:1;transform:none}}@-webkit-keyframes fx-animation-fadeInDown5px{0%{opacity:0;transform:translate3d(0,-5px,0)}to{opacity:1;transform:none}}@keyframes fx-animation-fadeInDown5px{0%{opacity:0;transform:translate3d(0,-5px,0)}to{opacity:1;transform:none}}@-webkit-keyframes fx-animation-fadeOutUp20px{0%{opacity:1;transform:none}to{opacity:0;visibility:hidden;transform:translate3d(0,-20px,0)}}@keyframes fx-animation-fadeOutUp20px{0%{opacity:1;transform:none}to{opacity:0;visibility:hidden;transform:translate3d(0,-20px,0)}}@-webkit-keyframes fx-animation-fadeInRight200px{0%{opacity:0;transform:translateX(200px)}to{opacity:1;transform:none}}@keyframes fx-animation-fadeInRight200px{0%{opacity:0;transform:translateX(200px)}to{opacity:1;transform:none}}@-webkit-keyframes fx-animation-slideInRight{0%{opacity:0;transform:translateX(-100%)}to{opacity:1;transform:none}}@keyframes fx-animation-slideInRight{0%{opacity:0;transform:translateX(-100%)}to{opacity:1;transform:none}}@-webkit-keyframes fx-animation-slideInLeft{0%{opacity:0;transform:translateX(100%)}to{opacity:1;transform:none}}@keyframes fx-animation-slideInLeft{0%{opacity:0;transform:translateX(100%)}to{opacity:1;transform:none}}.expandToFullScreen{-webkit-animation:fx-animation-expandToFullScreen 1s;animation:fx-animation-expandToFullScreen 1s}@-webkit-keyframes fx-animation-expandToFullScreen{0%{box-shadow:0 0 0 20px hsla(0,0%,100%,.3)}to{box-shadow:0 0 0 3500px rgba(0,0,0,.5)}}
</style>
